import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, filter, Observable, Subject, switchMap, tap } from "rxjs";
import { Risk, RiskPaginatedResponse } from "./risk.interface";
import { environment } from "../../../../../../environments/environment";
import { UserServiceApi } from "../../../../../api/service/user.service";
import { UserInfo } from "../../../../../api/model/user";

@Injectable({
    providedIn: 'root'
})
export class RiskService {

    public risksSubject: BehaviorSubject<Risk[]> = new BehaviorSubject<Risk[]>([]);
    public risks$ = this.risksSubject.asObservable();
    public riskLoading: Subject<boolean> = new Subject<boolean>();

    constructor(private http: HttpClient, private userService: UserServiceApi) {}

    reload(): void {
        console.log('Reloading risks');
        this.riskLoading.next(true);
        this.userService.userBehaviorSubject.asObservable().pipe(
            filter((user): user is UserInfo => !!user && !!user.id), 
            switchMap(user => this.listAllRisk(user.id || ''))
          ).subscribe({
            next: (risks) => {
              this.riskLoading.next(false);
              this.risksSubject.next(risks);
              console.log('Riscos carregados:', risks);
            },
            error: (err) => {
              this.riskLoading.next(false);
              console.error('Erro ao carregar riscos:', err);
            }
          });

    }

    listAllRisk(userId: string): Observable<Risk[]> {
        const url = environment.dataMapping.riskUrl.listAll.replace('{userId}', userId);
        return this.http.get<Risk[]>(url);
    }

    listAllRiskPaginated(userId: string, size: string, lastKey: string): Observable<RiskPaginatedResponse> {
        const url = environment.dataMapping.riskUrl.listAllPaginated.replace('{userId}', userId);

        return this.http.get<RiskPaginatedResponse>(url, { params: { size, lastKey } });
    }

    // Método para obter riscos do usuário atual (usa o BehaviorSubject)
    getCurrentUserRisks(): Observable<Risk[]> {
        return this.userService.userBehaviorSubject.pipe(
            switchMap(user => {
                if (user?.id) {
                    return this.listAllRisk(user.id);
                }
                return [];
            })
        );
    }

    // Método para criar risco
    createRisk(risk: Risk): Observable<any> {
        return this.http.post(environment.dataMapping.riskUrl.create, risk);
    }

    // Método para atualizar risco
    updateRisk(risk: Risk, id: string): Observable<any> {
        const url = environment.dataMapping.riskUrl.update.replace('{id}', id);
        return this.http.put(url, risk);
    }

    // Método para deletar risco
    deleteRisk(id: string): Observable<any> {
        const url = environment.dataMapping.riskUrl.delete.replace('{id}', id);
        return this.http.delete(url);
    }
}